//
// Slideshow store
//
// Stores and manages all activity around the slide shows that can be
// presented by a user with 'museum_teacher' status true.
//

import * as client from "../../api/client";
import {normalize} from "normalizr";
import { slideShow as slideShowSchema } from 'api/schema';
import {resetMap, setCollections, setOverlay, setStyle, setThemes, setViewport} from "./map";
import {hideMenu, openSection, showMenu} from "./menu";
import {LOGOUT} from "./auth";

// ------------------------------------
// Action definitions
// ------------------------------------

export const SELECT_SLIDE_SHOW = 'SLIDE_SHOWS/SELECT';
export const SELECT_SLIDE_IDX = 'SLIDE_SHOWS/SELECT_SLIDE_IDX';
export const REQUEST_SLIDE_SHOWS = 'SLIDE_SHOWS/REQUEST';
export const RECEIVE_SLIDE_SHOWS = 'SLIDE_SHOWS/RECEIVE';

// ------------------------------------
// Actions creators
// ------------------------------------

// always use the selectSlideIdxWithMapUpdates version externally!
const selectSlideIdx = idx => ({
  type: SELECT_SLIDE_IDX,
  idx
});

const selectSlideShow = id => ({
  type: SELECT_SLIDE_SHOW,
  id
});

export const closeSlideShow = () => ({
  type: SELECT_SLIDE_SHOW,
  id: null
});

export const fetchSlideShows = () => dispatch => {
  dispatch({ type: REQUEST_SLIDE_SHOWS });

  return client.get('/api/public/slideshows')
    .then(json => {
      const { entities } = normalize(json, [ slideShowSchema ]);
      const { slideShows } = entities;
      dispatch({ type: RECEIVE_SLIDE_SHOWS, slideShows });
    })
    .catch(console.error);
};

export const selectSlideIdxWithMapUpdates = idx => ((dispatch, getState) => {
  // logic here that can dispatch actions or read state

  // 'peek' into the new slide
  const state = getState();

  // ceck if this slide is of type 'map'
  const newSlideContent = getSlideAtIdx(idx, state.slideShows);

  if (newSlideContent && newSlideContent.type === 'slide_map') {
    console.log('Slide is a map!', newSlideContent);
    dispatch(resetMap())
    // perform side effects...
    const mapConfig = newSlideContent.config;
    if (mapConfig) {
      // show menu?
      if (mapConfig.hasOwnProperty('menu')) {
        if (mapConfig.menu) {
          dispatch(showMenu())
        } else {
          dispatch(hideMenu())
        }
      }

      // open part of the menu if requested
      if (mapConfig.hasOwnProperty('menu_open_section')) {
        dispatch(openSection(mapConfig.menu_open_section))
      }

      // you can show _either_ collections _or_ themes, so don't try to show them both!
      if (mapConfig.collections && mapConfig.collections.length > 0) {
        dispatch(setCollections(mapConfig.collections));
      } else if (mapConfig.themes && mapConfig.themes.length > 0) {
        dispatch(setThemes(mapConfig.themes));
      } else {
        // select none
        dispatch(setCollections([]));
      }

      // map style (normal, satellite, reduced contrast for overlay)
      if (mapConfig.map_style) {
        dispatch(setStyle(mapConfig.map_style));
      }

      //   'overlay' => 'grachtengordel_1657',
      // overlay (oude kaarten)
      if (mapConfig.overlay) {
        dispatch(setOverlay(mapConfig.overlay));
      }

      // map position / zoom
      //     'viewport' => [
      //     'center' => [
      //     52.3728, 4.8895
      //   ],
      //     'zoom' => 14
      // ],
      if (mapConfig.viewport) {
        if (mapConfig.viewport.center && mapConfig.viewport.zoom) {
          dispatch(setViewport({center: mapConfig.viewport.center, zoom: mapConfig.viewport.zoom}));
        }
      }

    }
  }

  // select the slide itself
  dispatch(selectSlideIdx(idx));
});

export const selectSlideIdxWithInit = idx => ((dispatch, getState) => {
  dispatch(selectSlideShow(idx));
  dispatch(selectSlideIdxWithMapUpdates(0));
});



// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {},
  selected: null,
  selectedSlideIdx: null,
  pending: false
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    // Set selected class.
    case SELECT_SLIDE_SHOW: {
      return { ...state, selected: action.id, selectedSlideIdx: null };
    }
    case SELECT_SLIDE_IDX: {
      return { ...state, selectedSlideIdx: action.idx };
    }
    case REQUEST_SLIDE_SHOWS: {
      return { ...state, pending: true };
    }
    case RECEIVE_SLIDE_SHOWS: {
      const { slideShows } = action;
      const items = { ...state.items, ...slideShows }
      return { ...state, items, pending: false  };
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

// ------------------------------------
// Utils
// ------------------------------------

export const getSelectedSlideShow = state => {
  const { items, selected } = state;
  return selected
    ? items[selected]
    : null;
};

export const getSlideAtIdx = (slideIdx, state) => {
  const { items, selected } = state;
  const slideShow = selected
    ? items[selected]
    : null;
  const slide = slideShow && slideIdx !== null
    ? slideShow.slides[slideIdx]
    : null;
  return slide;
};

export const getSelectedSlide = state => {
  const { items, selected, selectedSlideIdx } = state;
  const slideShow = selected
    ? items[selected]
    : null;
  const slide = slideShow && selectedSlideIdx !== null
    ? slideShow.slides[selectedSlideIdx]
    : null;
  return slide;
  // const { selectedSlideIdx } = state;
  // return getSlideAtIdx(selectedSlideIdx, state);
};

export const hasNextSlide = state => {
  const { items, selected, selectedSlideIdx } = state;
  const slideShow = selected
    ? items[selected]
    : null;
  if (slideShow && slideShow.slides && selectedSlideIdx !== null) {
    return selectedSlideIdx < slideShow.slides.length - 1
  }
  return false;
};

export const hasPreviousSlide = state => {
  const { items, selected, selectedSlideIdx } = state;
  const slideShow = selected
    ? items[selected]
    : null;
  if (slideShow && slideShow.slides && selectedSlideIdx !== null) {
    return selectedSlideIdx > 0;
  }
  return false;
};


// WEBPACK FOOTER //
// ./src/store/modules/slideShows.js